<template>
  <div class="ckgl_content">
    <el-row type="flex" justify="space-around" style="width: 100%; height: 33%">
      <div class="ckgl_block">
        <img :src="imgs.img01" alt="" class="sbgl_animation" />
        <div class="ckgl_box">
          <span class="ckgl_desc">原料库存量</span>
          <countTo
            class="ckgl_count"
            :startVal="0"
            :endVal="form.materialNum * 1"
            :duration="3000"
          ></countTo>
        </div>
      </div>
      <div class="ckgl_block">
        <img :src="imgs.img02" alt="" class="sbgl_animation" />
        <div class="ckgl_box">
          <span class="ckgl_desc">成品库存量</span>
          <countTo
            class="ckgl_count"
            :startVal="0"
            :endVal="form.productNum * 1"
            :duration="3000"
          ></countTo>
        </div>
      </div>
      <div class="ckgl_block">
        <img :src="imgs.img03" alt="" class="sbgl_animation" />
        <div class="ckgl_box">
          <span class="ckgl_desc">进料退货率</span>
          <span class="ckgl_count"
            ><countTo
              :startVal="0"
              :endVal="form.feedRate * 1"
              :duration="3000"
            ></countTo
            >%</span
          >
        </div>
      </div>
      <div class="ckgl_block">
        <img :src="imgs.img04" alt="" class="sbgl_animation" />
        <div class="ckgl_box">
          <span class="ckgl_desc">销售退货率</span>
          <span class="ckgl_count"
            ><countTo
              :startVal="0"
              :endVal="form.saleRate * 1"
              :duration="3000"
            ></countTo
            >%</span
          >
        </div>
      </div>
    </el-row>
    <el-row type="flex" justify="space-around" style="width: 100%; height: 66%">
      <div style="height: 95%">
        <img
          :src="imgs.imgleft"
          alt=""
          style="height: 100%"
          class="sbgl_animation"
        />
      </div>
      <div class="ckgl_right">
        <el-row
          type="flex"
          justify="space-around"
          style="width: 100%; height: 49%"
        >
          <div class="ckgl_right_block">
            <img :src="imgs.img001" alt="" class="sbgl_animation" />
            <div class="ckgl_right_box">
              <span class="ckgl_right_desc">进料数</span>
              <countTo
                class="ckgl_right_count"
                :startVal="0"
                :endVal="form.issueLineNum * 1"
                :duration="3000"
              ></countTo>
            </div>
          </div>
          <div class="ckgl_right_block">
            <img :src="imgs.img002" alt="" class="sbgl_animation" />
            <div class="ckgl_right_box">
              <span class="ckgl_right_desc">成品包装数</span>
              <countTo
                class="ckgl_right_count"
                :startVal="0"
                :endVal="form.productRecptNum * 1"
                :duration="3000"
              ></countTo>
            </div>
          </div>
        </el-row>
        <el-row
          type="flex"
          justify="space-around"
          style="width: 100%; height: 49%"
        >
          <div class="ckgl_right_block">
            <img :src="imgs.img003" alt="" class="sbgl_animation" />
            <div class="ckgl_right_box">
              <span class="ckgl_right_desc">退料数</span>
              <countTo
                class="ckgl_right_count"
                :startVal="0"
                :endVal="form.rtIssueNum * 1"
                :duration="3000"
              ></countTo>
            </div>
          </div>
          <div class="ckgl_right_block">
            <img :src="imgs.img004" alt="" class="sbgl_animation" />
            <div class="ckgl_right_box">
              <span class="ckgl_right_desc">销售退货数</span>
              <countTo
                class="ckgl_right_count"
                :startVal="0"
                :endVal="form.rtSalseNum * 1"
                :duration="3000"
              ></countTo>
            </div>
          </div>
        </el-row>
      </div>
    </el-row>
  </div>
</template>
<script>
import countTo from "vue-count-to";
import { getStockCount, getWarehouseStatisticsCount, getReturnRate } from '@/api/index'
export default {
  components: {
    countTo,
  },
  data () {
    return {
      imgs: {
        img01: require("@/assets/imgs/iconyl.png"),
        img02: require("@/assets/imgs/iconcp.png"),
        img03: require("@/assets/imgs/iconjl.png"),
        img04: require("@/assets/imgs/iconxs.png"),
        imgleft: require("@/assets/imgs/ck.png"),
        img001: require("@/assets/imgs/001.png"),
        img002: require("@/assets/imgs/002.png"),
        img003: require("@/assets/imgs/003.png"),
        img004: require("@/assets/imgs/004.png"),
      },
      form: {
        materialNum: 0,
        productNum: 0,
        issueLineNum: 0,
        productRecptNum: 0,
        rtIssueNum: 0,
        rtSalseNum: 0,
        feedRate: 0,
        saleRate: 0,
      }
    };
  },
  mounted () {
    this.getStockCounts()
    this.getWarehouseStatisticsCounts()
    this.getReturnRates()
  },
  methods: {
    async getStockCounts () {
      let result = await getStockCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'form', result.data)
      }
    },
    async getWarehouseStatisticsCounts () {
      let result = await getWarehouseStatisticsCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this.form, 'issueLineNum', result.data.issueLineNum)
        this.$set(this.form, 'productRecptNum', result.data.productRecptNum)
        this.$set(this.form, 'rtIssueNum', result.data.rtIssueNum)
        this.$set(this.form, 'rtSalseNum', result.data.rtSalseNum)
      }
    },
    async getReturnRates () {
      let result = await getReturnRate({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this.form, 'feedRate', result.data.feedRate)
        this.$set(this.form, 'saleRate', result.data.saleRate)
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.ckgl_content {
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  .ckgl_block {
    display: flex;
    justify-content: center;
    align-items: center;
    .ckgl_box {
      height: 70%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: space-between;
      .ckgl_desc {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
      .ckgl_count {
        font-family: DIN;
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
  .ckgl_right {
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    width: 58%;
    height: 100%;
    .ckgl_right_block {
      position: relative;
      img {
        height: 98%;
      }
      .ckgl_right_box {
        height: 65%;
        position: absolute;
        top: 12px;
        left: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-content: space-between;
        .ckgl_right_desc {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
        .ckgl_right_count {
          font-family: DIN;
          font-weight: bold;
          font-size: 22px;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
.sbgl_animation {
  animation: breathLamp 3s alternate infinite;
}
@keyframes breathLamp {
  // 0% {
  //   opacity: 0.2;
  // }
  // 100% {
  //   opacity: 1;
  // }
  0% {
    transform: scale(0.9); /* 初始状态 */
  }
  50% {
    transform: scale(1); /* 放大 */
  }
  100% {
    transform: scale(0.9); /* 恢复到初始状态 */
  }
}
</style>
